import React, { useEffect, useState } from 'react';
import {
  DragDropContext,
  DraggableChildrenFn,
  DropResult,
  Droppable,
  DroppableProvided,
} from 'react-beautiful-dnd';
import { ClipPreviewMap } from '../../context/previewClip/StudioPreviewClipContext';
import StudioClipList from '../StudioClipList';
import { ClipObject, ClipObjectPending } from '../../context/clips';
import { ClipRendererProps } from '../StudioClipList/StudioClipList';

const DROPPABLE_ID = 'StudioClipPreviewList-droppable';

const StudioClipPreviewList = ({
  previews,
  onDragEnd,
  clipRenderer,
  handleRenderDroppableClone,
}: {
  previews: ClipPreviewMap;
  onDragEnd: (result: DropResult) => void;
  clipRenderer: (props: ClipRendererProps) => React.ReactNode;
  handleRenderDroppableClone?: DraggableChildrenFn | undefined;
}) => {
  const [previewsArr, setPreviewsArr] = useState<
    ClipObject[] | ClipObjectPending[]
  >();

  useEffect(() => {
    /**
     * Convert preview map into an array for StudioClipList component
     */
    const arr = previews
      ? Array.from(previews).map(([clipId, clip], _index) => ({
          ...clip,
          id: clipId,
        }))
      : [];
    setPreviewsArr(arr);
  }, [previews]);

  return previewsArr?.length ? (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable
        droppableId={DROPPABLE_ID}
        mode="virtual"
        renderClone={handleRenderDroppableClone}
      >
        {(droppableProvided: DroppableProvided) => (
          // eslint-disable-next-line @typescript-eslint/unbound-method
          (<div ref={droppableProvided.innerRef}>
            <StudioClipList
              clips={previewsArr}
              autoloadFn={() => {}}
              autoloadDisabled={false}
              droppableProvided={droppableProvided}
              clipRenderer={clipRenderer}
            />
          </div>)
        )}
      </Droppable>
    </DragDropContext>
  ) : null;
};

export default StudioClipPreviewList;
